import { AuditWrapper } from '../../../components/hub/AuditWrapper';
import { FoundationsPage } from '../../FoundationsPage';

export function HubFoundationsPage() {
  return (
    <AuditWrapper>
      <FoundationsPage />
    </AuditWrapper>
  );
}
